// extracted by mini-css-extract-plugin
module.exports = {"Solution":"Solution_Solution__744cv"};